import React from 'react'
import { Redirect } from 'react-router'

const NotFound: React.FC = ()=>{
    return(
        <Redirect to="/"/>
    )
}

export default NotFound